<h2 mat-dialog-title>{{ data.title | async }}</h2>

@if (data.message) {
    <mat-dialog-content>
        {{ data.message | async }}
    </mat-dialog-content>
}

<mat-dialog-actions align="end">
    <button matButton="filled" class="btn-secondary" [mat-dialog-close]="false">
        {{ cancelLabel | async }}
    </button>
    <button matButton="filled" [class]="data.destructive ? 'btn-error' : 'btn-primary'" [mat-dialog-close]="true">
        {{ confirmLabel | async }}
    </button>
</mat-dialog-actions>